import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { takeUntil } from "rxjs/operators";
import { CheckBrachAccessModel } from "../../data-center-process/chek-branch-access.model";
import { RoleFormComponent } from "../role-form/role-form.component";
@Component({
  selector: "role-list",
  templateUrl: "role-list.component.html",
  styleUrls: ["role-list.component.scss"],
})
export class RoleListComponent extends BaseListComponent {
  isloaded: boolean = false;
  IgnoreDelete: boolean = false;
  deleteMessage: string = "";
  constructor() {
    super();
    this.inputEditorform = RoleFormComponent;
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.Role.Name"),
      name: "Name",
      order: 0,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "Name",
      maxLength: 256,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.Role.DisplayName"),
      name: "DisplayName",
      order: 1,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "Description",
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.Role.Description"),
      name: "Description",
      order: 1,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "Description",
    });
    this.FillData();
  }

  ngOnInit() {
    this.apiName = "Role";
    this.areaName = "General";
    this.label = this.translate("ClientApp.GNR.Role.UserRole");
    this.accountService.authService.getMvcController();
  }

  canManageForms(action: string) {
    if (this.isloaded) return true;
    return this.accountService.userHasPermission(`${this.areaName}:${this.apiName}`, action);
  }

  ngAfterViewInit(): void {
    this.isloaded = true;
  }

  async FillData() {
    const currentInformation = this.accountService.authService.currentInformation();
    if (currentInformation?.BranchingLightEnabled || currentInformation?.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch/Security")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.IgnoreDelete = true;
              this.deleteMessage = this.translate("ClientApp.GNR.Role.InfoBranchCanNotDeleted");
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.IgnoreDelete = true;
                this.deleteMessage = this.translate("ClientApp.GNR.Role.InfoCentralOfficeCanNotDeleted");
                return;
              }
            }
          }
        });
    }
    if (currentInformation?.RestaurantCallCenter && !this.accountService.authService.currentBranch?.AccessToAllBranches) {
      this.isAdd = false;
      this.isEdit = false;
      this.isDelete = false;
    }
  }
}
